//------------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 地図/径間ポップアップ
//------------------------------------------------------------------------------
import Graphic from '@arcgis/core/Graphic';
import Polyline from '@arcgis/core/geometry/Polyline';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import PoleLink from '@/utils/pole-link';
import mapUtils from '@/utils/map-utils';
import closePopup from './close-popup.js'

// 定数
const LOGH = 'BFA10104G link popup:';

/**
 * 選択径間ポップアップ
 *
 * @param {MapView} view  地図ビュー
 * @param {object} layer  レイヤー格納オブジェクト
 * @param {PoleLink} linkSelected   選択中の径間(電柱リンク)
 * @param {PopupTemplate} template  ポップアップテンプレート
 */
export function openLinkPopup(view, layers, linkSelected, template) {
  if (!view || !layers) {
    return;
  }

  // 選択径間なしならポップアップ非表示
  if (!linkSelected?.drawable()) {
    closePopup(view, layers);
    return;
  }

  // 既にポップアップ表示済の場合は何もしない
  if (view.popup.visible) {
    for (const graphic of view.popup.features) {
      const type = graphic.attributes.type;
      if (type !== 'keikan') {
        continue;
      }
      const link = graphic.attributes.link;
      if (linkSelected.same(link)) {
        return;
      }
    }
  }

  // 径間一覧の電柱グラフィックを検索
  let graphic = findGraphic(layers.keikan, linkSelected);
  if (!graphic) {

    // 径間一覧に存在しなければグラフィック描画
    // TODO 線が描画されない (ポップアップはする)
    layers.linker.removeAll();  // TODO
    graphic = drawGraphic(layers.linker, linkSelected, template);

    // TODO ポップアップ中の径間を径間一覧で削除した場合...
  }

  // 径間ポップアップ
  view.openPopup({
    location: graphic.geometry.extent.center,
    features: [ graphic ],
  });

  // 径間が表示範囲外ならビュー移動
  const innerView = view.extent.intersects(graphic.geometry);
  if (!innerView) {
    const center = graphic.geometry.extent.center;
    view.goTo(center, mapUtils.GOTO_OPTIONS)
        .catch((err) => console.info(LOGH, err.message));
  }
}

// デフォルトエクスポート
export default openLinkPopup;

//
// 径間グラフィック検索
//
function findGraphic(layer, linkSelected) {
  for (const graphic of layer.graphics) {

    // 径間電柱参照
    const { pole1, pole2 } = graphic.attributes.link;

    // 電柱x2一致判定
    const link = PoleLink.of(pole1, pole2);
    if (linkSelected?.same(link)) {
      return graphic;
    }
  }
  return null;
}

//
// 径間グラフィック描画
//
function drawGraphic(layer, linkSelected, template) {
  const { pole1st, pole2nd } = linkSelected;

  // ライン
  const polyline = new Polyline({
    paths: [
      [ pole1st.longitude, pole1st.latitude ],
      [ pole2nd.longitude, pole2nd.latitude ],
    ],
  });

  // 属性
  const attributes = {
    type: 'keikan',
    link: new PoleLink(pole1st, pole2nd),
  };

  // グラフィック作成
  const graphic = new Graphic({
    symbol: KEIKAN_SYMBOL,
    geometry: polyline,
    attributes: attributes,
    popupTemplate: template,
  });

  // グラフィック描画
  layer.add(graphic);
  return graphic;
}

// 径間シンボル
const KEIKAN_SYMBOL = new SimpleLineSymbol({
  style: 'solid',
  width: '4px',
  color: 'black',
  marker: null,
});
